/* eslint-disable max-lines */
/* eslint-disable max-len */

export default {
  lang: 'es',
  homeScreen: {
    title: '',
    stayConnected: 'Mantente conectado',
    comingSoon: 'Próximamente',
    downloadNow: 'Descargar ahora:',
    readMore: 'Más información ',
  },
  glassWidgets: {
    errors: {
      requestFailed: 'Algo salió mal. Inténtalo de nuevo más tarde.',
    },
    programStatus: {
      title: 'Mi Estado',
      loading: 'Cargando…',
      yourRep: 'Tu Representante',
      myProfile: 'Perfil',
      favorites: 'Favoritos',
      registeredOn: 'Fecha de ingreso:',
      graduatedOn: 'Fecha de graduación:',
      totalBadgesEarned: 'Total de Insignias Obtenidas:',
      lastBookingLogged: 'Última Reserva Registrada:',
      currentTier: 'Nivel Actual',
      lastBadgeEarned: 'Última Insignia Obtenida:',
      currentFocus: 'Enfoque Actual:',
    },
    todaysfocus: {
      title: 'Enfoque de Hoy',
      empty: 'No hay elementos de enfoque para hoy',
      loading: 'Cargando…',
      error: 'Algo salió mal',
      slideNavAria: 'Navegación de diapositivas',
      slideAria: 'Diapositiva',
      carouselAria: 'Enfoque de hoy',
    },
    welcome: '¡Bienvenido!',
    welcomeBack: '¡Bienvenido de nuevo, {firstName}!',
    notifications: {
      loading: 'Cargando…',
      empty: 'No hay notificaciones',
    },
    achievements: {
      title: 'Recompensas y Concursos',
      loading: 'Cargando…',
      lastBooking: 'Último Envío de Entrada',
      currentTier: 'Nivel Actual',
      contestEntries: 'Total de Entradas al Concurso',
      nightsBooked: 'Noches Reservadas',
      totalRevenue: 'Ingresos Totales Reportados',
      noBookingData: 'No hay datos de reservas disponibles.',
      fileUploadSuccess: 'El archivo se ha subido correctamente.',
      quickSubmit: {
        title: 'Envío rápido',
        uploading: 'Subiendo…',
        clear: 'Borrar',
        submit: 'Enviar',
        submitSuccessSimulated: 'Reserva enviada correctamente',
      },
    },
  },
  profileImageView: {
    currentImage: 'Tu imagen de perfil actual:',
    uploadImage: 'Sube tu imagen de perfil:',
    chooseAFile: 'Elige un archivo…',
    cancel: 'cancelar',
    backButton: 'Volver',
    uploadButton: 'Subir imagen de perfil',
    saveButton: 'Guardar esta imagen de perfil',
    fileTooLargeTitle: 'Tamaño de carga excedido',
    fileTooLargeText: 'El tamaño máximo de imagen para subir es 10 MB',
  },
  notification: {
    newAndNow: '¡Nuevo y Ahora!',
    alert: 'Alerta',
    message: 'Mensaje',
    contest: 'Concurso',
    badge: 'Nueva Insignia',
    'content-update': 'Actualización de Contenido',
    events: 'Eventos',
    other: 'Notificación',
    welcome: 'Bienvenido',
  },
  sharing: {
    email: 'Correo electrónico',
    download: 'Descargar',
    copyURL: 'Copiar enlace',
    copied: 'Copiado',
    shareSubjectBadge: 'Insignia de especialista en Estados Unidos',
  },
  shareSubjectDiploma: 'Diploma de especialista en Estados Unidos',
  loginScreen: {
    version2: {
      accountCreated: 'Se ha creado una cuenta, por favor revise su correo electrónico para completar el proceso.',
      homeTitle: 'Veamos si podemos encontrar un perfil existente para ti en nuestro sistema.',
      homeTitleSub:
        'Ingresa la dirección de correo electrónico que normalmente utilizas para iniciar sesión en programas de formación.',
      noAccount:
        'No se encontró ninguna cuenta ({email}), intenta con otro correo electrónico o crea una cuenta ahora.',
      continueButton: 'Continuar',
      success: '¡Tu cuenta se actualizó correctamente! En breve serás redirigido a la página de inicio.',
      successNewAccount:
        'Para completar el registro, recibirás un correo electrónico de confirmación para verificar tu cuenta.',
      loginButton: 'Iniciar sesión',
      matchFound: 'Encontramos una coincidencia, ingresa tu contraseña para continuar.',
      magicLink: 'Inicia sesión con un enlace enviado a tu correo electrónico:',
      magicLinkButton: 'Solicitar enlace mágico',
      magicLinkTitle: 'Recibe un enlace directo en tu correo electrónico para iniciar sesión al instante.',
      otherEmailButton: 'Enviar',
      title:
        'Tómate un momento para completar toda la información a continuación, ya que con ella se rellenará tu perfil personal y tu información de contacto.',
      titleIndustry:
        'Tómate un momento para completar toda la información a continuación, ya que con ella se rellenará tu perfil personal y tu información de contacto.',
      register: 'Crear una cuenta',
      agent: 'Asesor de viajes',
      visitor: 'Visitante de la industria',
      step1: 'Primer paso: Elegir el tipo de usuario',
      step2: 'Segundo paso: Crear una cuenta',
      step3: 'Tercer paso: Crear tu perfil',
      marketingOptIn:
        '¿Estás seguro de que no te interesa mantenerte conectado con el equipo comercial de viajes de este programa?',
      optIn: 'Sí, me interesa',
      optOut: 'No me interesa',
      step2Sub1: 'Cuéntanos sobre ti',
      step2Sub2: 'Cuéntanos sobre tu negocio',
      privacyHead: 'PREFERENCIAS DE COMUNICACIÓN',
      privacySub:
        'Marca las casillas que aparecen a continuación para asegurarte de recibir comunicaciones importantes del equipo comercial de viajes del proveedor (actualizaciones y anuncios de productos, recompensas, incentivos, FAM, etc.) e iniciativas de redes comerciales de viajes y soporte de ventas de TravPRO Mobile.',
      privacy: 'Protegemos tu privacidad y nunca vendemos, abusamos o traicionamos tu confianza.',
      store: 'Descarga fácilmente este programa en tu tienda de aplicaciones:',
      powered: 'CON LA TECNOLOGÍA DE',
      toastMessage: {
        forgotSuccess:
          'Te enviamos un enlace de restablecimiento de contraseña por correo electrónico. Serás redirigido a la página de inicio de sesión en 10 segundos.',
        emailNotExisting: 'La dirección de correo electrónico que ingresaste no existe.',
        magicLinkMessage: 'Espera, te estamos registrando.',
        magicLinkError:
          'No pudimos encontrar tu cuenta en nuestra base de datos, inicia sesión manualmente. Serás redirigido en 10 segundos.',
        magicLinkError1:
          'No pudimos encontrar un token válido, inicia sesión o solicita un nuevo enlace mágico. Si el problema persiste, comunícate con nosotros en: info@travpromobile.com.',
        magicLinkError2:
          'No pudimos encontrar tu cuenta en nuestra base de datos, inicia sesión manualmente. Serás redirigido en 10 segundos.',
        magicLinkSuccess: 'Revisa tu correo electrónico {email}. Encontrarás un enlace mágico para registrarte.',
        magicLinkErrorWait: 'Espera 5 minutos entre cada solicitud de enlace mágico.',
        emailNotFoundError:
          'La dirección de correo electrónico que ingresaste no se encuentra en nuestros registros. Revisa si hay errores ortográficos o crea una cuenta.',
      },
      errors: {
        zipCodeNotFound: 'No se encontró el código postal, inténtalo de nuevo',
        zipCodeOnlyNumbers: 'El código postal solo puede contener números',
        password: 'Ingresa una contraseña',
        passwordNotMatching: 'Las contraseñas que ingresaste no coinciden',
        passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
        emailExists:
          'Esta dirección de correo electrónico ya existe o no es válida. Intenta con otra dirección de correo electrónico o inicia sesión en tu cuenta.',
        fillInAllFields: 'Completa todos los campos obligatorios',
        fillInEmail: 'Ingresa tu correo electrónico.',
        emailNotExisting: 'La dirección de correo electrónico que ingresaste no existe.',
      },
      fields: {
        forgotSubCopy: '¿Olvidaste tu contraseña y quieres cambiarla? ',
        forgotSubCopy2:
          '¿Quieres omitir la contraseña? Te enviaremos un correo electrónico con un enlace mágico que te registrará automáticamente en el programa. ',
        city: 'Ciudad',
        companyName: 'Nombre de la empresa',
        role: 'Tu función (selecciona una)',
        description: '¿Cuál de las siguientes opciones describe mejor la actividad de tu empresa?',
        country: 'País',
        password: 'Contraseña',
        passwordRegister: 'Elegir contraseña (mínimo 8 caracteres)',
        passwordConfirm: 'Confirmar contraseña',
        firstName: 'Nombre',
        lastName: 'Apellido',
        agency: 'Nombre de tu agencia',
        title: 'Tu función (selecciona una)',
        company: 'Nombre de la empresa',
        select: 'Selecciona una de las siguientes opciones',
        state: 'Estado',
        province: 'Provincia/región/estado',
        zipCode: 'Código postal',
        postalCode: 'Código postal',
        affiliate: '¿A qué grupo está afiliada tu agencia PRINCIPAL?',
        hostAgency: '¿Tu agencia anfitriona?',
        executive: 'Ejecutivo',
        management: 'Gerente',
        marketing: 'Marketing',
        sales: 'Ventas',
        coordinator: 'Coordinador',
        opt: 'Manténgase conectado con el equipo de Brand USA y reciba las actualizaciones del programa USA Discovery',
        optMarketing: 'Mantente conectado a TravPRO para enterarte de programas de aprendizaje adicionales',
        retail: 'Tienda minorista',
        home: 'Agente a domicilio',
        independent: 'Contratista independiente',
        host: 'Agencia anfitriona',
        call: 'Centro de llamadas o agencia web',
        other: 'Otro ',
        describes: '¿Qué es lo que mejor describe tu negocio y el de tu agencia? ',
      },
    },
    title: 'Formación de profesionales de viajes y programa de capacitación de ventas',
    welcome: {
      headerTop: 'Bienvenido al',
      headerBottom: 'Programa de descubrimiento de EE. UU.',
    },
    sellingPoints: {
      0: 'Aprende, promociona y vende en cualquier lugar',
      1: 'Formación multimedia en todos los dispositivos',
      2: 'Certificado de finalización',
      3: 'Experiencia e insignias de socios',
      4: 'Materiales promocionales para compartir',
      5: 'Recursos de ventas 24/7',
      6: 'Recompensas de formación',
      7: 'Incentivos y MegaFams',
    },
    tAndC: {
      agree: 'Al continuar, aceptas nuestra ',
      privacyPolicy: 'política de privacidad',
      and: ' y nuestros ',
      termsConditions: 'términos y condiciones',
    },
    fields: {
      select: 'Selecciona una de las siguientes opciones',
      country: 'País',
      agency: 'Agencia',
      email: 'Correo electrónico',
      password: 'Contraseña',
      passwordConfirm: 'Confirma tu contraseña',
      firstName: 'Nombre',
      lastName: 'Apellido',
      address: 'Dirección',
      postalCode: 'Código postal',
      city: 'Ciudad',
      agencyName: 'Nombre de la agencia',
      stateProvince: 'Estado/provincia',
      required: 'Obligatorio',
      invalidEmail: 'Dirección de correo electrónico no válida',
      opt: '¡Mantente en contacto! Sí, me gustaría recibir comunicaciones de Brand USA para mantenerme informado sobre noticias, eventos, incentivos, FAM y más.',
      forgot:
        '¿Olvidaste tu contraseña? Haz clic en el botón que aparece a continuación y te enviaremos un correo electrónico para restablecer tu contraseña.',
    },
    forgot: 'Restablecer contraseña',
    noAgent: {
      noAgentButton: 'No soy un agente',
      title: 'Gracias por tu interés en el Programa de descubrimiento de Estados Unidos.',
      messageWeb:
        'El contenido de este sitio es exclusivo para profesionales de viajes. \n Para obtener más información sobre Brand USA, visita: ',
      messageMobile:
        'Algunos contenidos de esta aplicación son exclusivos para profesionales de viajes, pero puedes navegar por una vista previa de lo que esta aplicación ofrece si presionas “Continuar”.',
      continue: 'Continuar',
      visitWebsite: 'Visitar el sitio web',
    },
    newUser: 'Nuevo usuario',
    register: 'Registrarse',
    registered: 'Este correo electrónico ya está registrado',
  },
  welcomeScreen: {
    title: 'Bienvenido al Programa de descubrimiento de Estados Unidos',
    helloUser: 'Hola, {{name}}',
    hello: 'Hola,',
    fromAgency: 'de {{agency}}',
    notUser: '¿No eres {{name}}?',
    startTraining: 'Comenzar a aprender',
    continueTraining: 'Continuar aprendiendo',
    graduated: '¡Felicidades!',
    downloader: {
      stop: 'detener',
      init: 'Iniciando…',
      lastUpdate: 'Última actualización: ',
    },
  },
  trainingScreens: {
    comingSoon: 'Próximamente: {title}',
    categoryLockMinimum: 'Desbloquea al menos {number} de las formaciones incluidas para acceder a esta categoría.',
    allUnlocked: '¡Desbloqueaste todos los capítulos!',
    completedBase: '¡Felicitaciones, eres un especialista certificado en Estados Unidos!',
    certificate: 'Certificado',
    chapter: 'Capítulo',
    chapterComplete: '¡Capítulo completado!',
    choose: 'Selecciona una respuesta',
    confirm: 'Confirma tu respuesta',
    continue: 'Continuar',
    courseComplete: '¡Curso completado!',
    durationInMinutes: '{number} minutos',
    endReached: 'Llegaste al final',
    essential: 'Fundamentos',
    essentialSub:
      'Completa estos capítulos esenciales para obtener tu diploma y desbloquear las especializaciones a continuación.',
    message: '{count} mensaje',
    messagePlural: '{count} mensajes',
    percentageComplete: '{number}% completado',
    restart: 'Revisar',
    review: 'Revisar',
    retainEnd:
      'Utiliza la barra superior para desplazarte por este capítulo o presiona el botón Atrás para volver al resumen.',
    retry: 'Volver a intentar',
    skip: 'Volver >',
    viewAllTitle: 'Consejo de formación',
    badge: 'Descargar insignia',
    viewAll:
      'Antes de pasar a la página siguiente, tómate un momento para revisar todo el contenido, incluidos los íconos, ya que ofrecen información adicional que te ayudará a convertirte en un experto.',
    start: 'Comenzar',
    status: 'Estado actual:',
    trouble:
      'Parece que tienes problemas, vuelve a leer el contenido de la(s) página(s) anterior(es) e inténtalo de nuevo.',
    unlockDefault: 'Desbloquea este capítulo completando el anterior.',
    unlock: 'Desbloquea este capítulo completando el capítulo de la formación.',
    unlockSubtitle: 'Desbloquea más capítulos completando los capítulos de la formación.',
    unlockFoundation: 'Para desbloquear estos capítulos, completa los Fundamentos.',
    watchListenRead: 'Ver, escuchar y leer más',
    completed: 'Completado',
  },
  trainingExtraScreens: {
    subtitle: 'EXPERIENCIAS',
    error: 'Lo sentimos. Se produjo un error',
    uncompletedTitle: 'EXPERIENCIAS SIN COMPLETAR DE {partner}',
    completedTitle: 'EXPERIENCIAS COMPLETADAS DE {partner}',
    noAvailableBadges: 'Actualmente no hay insignias disponibles.',
    interimScore: 'Completa',
    interimScoreEnd: 'capítulos más para conseguir tu insignia.',
    badgesComplete: '¡Felicidades! Conseguiste tu insignia:',
  },
  newTrainingFlow: {
    partnerModules: 'ESPECIALIZACIONES DE LOS SOCIOS',
    finishGold: 'Conoce a nuestros socios y consigue insignias completando estos capítulos.',
  },
  points: {
    complete: {
      chapter: '¡Capítulo completado!',
      'intro-chapter': 'Introducción ¡Capítulo completado!',
      'sub-app': 'Subaplicación completada',
      rewards: '¡Recompensas completadas!',
    },
    completed: '{completed} Insignias conseguidas',
  },
  nav: {
    home: 'Inicio',
    train: 'Aprender',
    learn: 'Aprender',
    retain: 'Recordar',
    promote: 'Promocionar',
    sell: 'Vender',
    info: 'Información',
    rewards: 'Recompensas',
    media: 'Medios',
    favorites: 'Favoritos',
    contact: 'Conéctate con nosotros',
    diploma: 'Diploma',
    accountSettings: 'Configuración de la cuenta',
    messages: 'Mensajes',
    search: 'Buscar',
    showcases: 'Escaparates',
  },
  contentHeaders: {
    subapps: 'ESPECIALIZACIONES DE LOS SOCIOS',
    maintrainings: 'Sucursales',
    subtrainings: 'Experiencias',
    itineraries: 'ITINERARIOS',
  },
  pageDescriptions: {
    train: 'Enseña, involúcrate y conviértete en un experto.',
    retain: 'Conserva tu conocimiento experto con este recurso de contenido fácil de usar.',
    promote:
      'Comparte estos artículos para despertar el interés y comenzar una conversación con clientes y posibles clientes.',
    sell: 'Responde las preguntas de los clientes y sé parte de Brand USA.',
    favorites: 'Tu contenido favorito.',
    search: 'Revisar todo el contenido',
    subapps: 'Conoce a nuestros socios y consigue insignias completando estos capítulos.',
    subtrainings: 'Perfecciona tus conocimientos y consigue una insignia para cada una de las siguientes secciones.',
    itineraries: 'Completa estos breves capítulos sobre rutas de carretera populares y consigue una insignia por cada uno.',
  },
  general: {
    website: 'https://www.thebrandusa.com/',
    forgot: '¿Olvidaste tu contraseña?',
    next: 'Siguiente',
    yes: 'Sí',
    no: 'No',
    previous: 'Anterior',
    submit: 'Enviar',
    register: 'Registrarse',
    back: 'Atrás',
    close: 'Cerrar',
    page: 'Página',
    search: 'Buscar',
    logIn: 'Iniciar sesión',
    logOut: 'Cerrar sesión',
    viewItem: 'Ver {type}',
    imageNotFound: 'No se encontró la imagen',
    noResultsFor: 'No se encontraron resultados para: {{query}}',
    noFavorites: 'Aún no tienes favoritos.',
    noMessages: 'Aún no has recibido ningún mensaje.',
    resultsFor: 'Resultados para: {{query}}',
    showAll: 'Mostrar todo',
    connectionError: 'Error de conexión',
    alreadyExists: 'Ya existe',
    pageNotFound: '404 No se encontró la página',
    oops: 'Vaya…',
    overview: 'Volver a la descripción general',
    complete: 'Continuar',
    courseComplete: '¡Capítulo completado!',
    chapterComplete: '¡Capítulo completado!',
    message: 'Mensaje ({count})',
    messagePlural: 'Mensajes ({count})',
  },
  itemTypes: {
    image: 'Imagen',
    brochure: 'Recopilación',
    layout: 'Diseño',
    web: 'Sitio web',
    pdf: 'PDF',
    carousel: 'Recopilación',
  },
  questions: {
    dials: 'Gira los selectores para que coincidan con la respuesta',
    fitb: 'Completa los espacios en blanco',
    flip: 'Cambia el número para que coincida con la respuesta',
    multipleChoice: 'Selecciona las respuestas correctas',
    slider: 'Elige la respuesta correcta con el control deslizante',
    map: 'Responde la pregunta tocando la ubicación correcta en el mapa',
    dropdown: 'Elige…',
    true: 'Verdadero',
    false: 'Falso',
  },
  reportCard: {
    download: 'Descargar',
    email: 'Correo electrónico',
    print: 'Imprimir',
  },
  cookies: {
    consent: 'ACEPTAR',
    optout: 'Cancelar la suscripción',
    settings: 'Configuración de privacidad',
    message:
      'No nos has dicho nada sobre tus preferencias de privacidad de datos. Está bien, pero nos gustaría ofrecerte la mejor experiencia al usar Sales Companion.',
    disabled: 'Parece que deshabilitaste el uso de cookies.',
    use: '{{appName}} requiere el uso de cookies para ofrecerte la mejor experiencia.',
    details: '¿Para qué se utilizan las cookies?',
    enable: 'Mira cómo habilitar tus cookies {{here}}.',
    here: 'aquí',
  },
  notLoggedIn: {
    super: 'No has iniciado sesión',
    title: 'Debes iniciar sesión para ver este contenido',
    guest: 'Huésped',
  },
  demo: {
    message:
      'Este sitio web es una demostración del producto final. Actualmente está en desarrollo y no es un producto completo.',
    consent: '¡Entendido!',
  },
  share: {
    header: '¡Comparte este recurso en tus redes sociales favoritas!',
    download: 'Descargar',
    email: 'Correo electrónico',
  },
  breadCrumbs: {
    page: 'Página',
  },
  storeButtons: {
    title: 'Obtén la aplicación en tu dispositivo móvil',
  },
  onMobile: {
    header: 'Parece que estás intentando acceder a la aplicación {appName} desde un dispositivo móvil',
    body: 'Para descargar este programa, simplemente visita tu tienda de aplicaciones y busca {appName} o haz clic en uno de los botones que aparecen a continuación',
    benefits: {
      1: 'Aprende, promociona y vende en cualquier lugar',
      2: 'Formación multimedia en todos los dispositivos',
      3: 'Certificado de finalización',
      4: 'Experiencia e insignias de socios',
      5: 'Materiales promocionales para compartir',
      6: 'Recursos de ventas 24/7',
      7: 'Recompensas de formación',
      header: 'Esto te proporcionará lo siguiente:',
    },
  },
  custom: {
    splitUsers: 'Soy…',
    brandAmbassador: 'Embajador de marca',
    travelPro: 'Profesional de viajes',
  },
  rewards: {
    menu: {
      home: 'Inicio\nRecompensas',
      achievements: 'Logros\nCapacitación',
      bookings: 'Incentivos\nInsignias',
      form: 'Enviar\nReservas',
    },
    rewards: 'Recompensas',
    title: 'Bienvenido al Centro de recompensas y logros',
    subheader: 'Haz seguimiento y comparte los logros e incentivos de la formación',
    button: 'Enviar tu reserva',
    viewAllBookings: 'Reservas',
    viewDashboard: 'Panel de puntos',
    viewRewards: 'Resumen',
    overview: {
      valid: '* Las reservas ingresadas solo son válidas una vez que el cliente completa su viaje.',
    },
    required: {
      rezsnap: 'Carga de prueba RezSnap™ es obligatoria',
    },
    home: {
      entries: 'Inscripciones actuales',
      trainingAchievements: 'LOGROS DE LA FORMACIÓN',
      trainingAchievementsText:
        'Haz un seguimiento del progreso de tu formación, las certificaciones y el estado de las recompensas metálicas en esta página. También podrás descargar y compartir tu diploma de Especialista en Estados Unidos, así como cualquier insignia que hayas conseguido en las Experiencias y especializaciones de socios.',
      bookingContests: 'PANEL DE INCENTIVOS',
      bookingContestsText:
        'Haz seguimiento y administra fácilmente los programas de incentivos actuales en el Panel de incentivos. ',
      submitBooking: 'ENVIAR RESERVAS',
      submitBookingText: 'Aquí es donde enviarás reservas para incluirlas en Incentivos por reservas.',
      currentContest: 'INCENTIVOS ACTUALES',
      noContests: 'Actualmente no hay incentivos por insignias.',
      ContestEndDate: 'El incentivo termina:',
      ContestDetails: 'Detalles del incentivo',
      ContestSeeProgram: 'Revisa los Términos',
      ContestTerms: 'Términos y condiciones del programa',
      ContestForDetails: 'para obtener más detalles.',
      ContestPartnerLink: 'Ir al socio',
      ContestLink: 'Ir al enlace',
    },
    bookingsView: {
      title: 'Reservas',
      infoMessage:
        'Ordena usando los botones de arriba y haz clic en cualquier registro para gestionar los detalles del envío. Todas las entradas pendientes se verificarán en un plazo de 72 horas',
    },
    leaderboardScreen: {
      prizes: 'Premios',
      tAndC: 'Se aplican los términos y condiciones*',
    },
    dashboardView: {
      title: 'Panel de incentivos',
      subtitle: 'Haz un seguimiento de tus actividades de incentivos aquí.',
      badge: 'Incentivos por insignias',
      activity: 'Incentivos por reservas',
      manage: 'Administrar reservas',
      manageSub:
        'Siga las reservas actuales a continuación o consulte las reservas archivadas utilizando el menú desplegable.',
      noBadgeIncentives: 'Actualmente no hay incentivos por insignias.',
      noBookings: 'No hay registros para mostrar.',
      state: {
        approvedEntries: 'Entradas Aprobadas',
        pendingEntries: 'Entradas pendientes',
        declinedEntries: 'Entradas rechazadas',
        viewAll: 'Ver Todos',
      },
      currentYear: 'Año en Curso',
      archivedBookings: 'Reservas Archivadas',
    },
    bookingForm: {
      title: 'Formulario de crédito para reservas en Estados Unidos',
      subTitle: 'Ingresa tu reserva:',
      required: '* Indica un campo obligatorio',
      email: 'Correo electrónico del asesor',
      agentFirstName: 'Nombre del asesor',
      agentLastName: 'Apellido del asesor',
      company: 'Nombre de la agencia/compañía',
      iata: 'N.° IATA/CLIA',
      stateProvince: 'Estado/provincia',
      postalCode: 'Código postal',
      country: 'País',
      city: 'Ciudad',
      birthday: 'Cumpleaños',
      type: 'Tipo de viaje del huésped',
      source: 'Fuente de reserva',
      tourOperator: 'Operador turístico',
      firstName: 'Nombre del huésped',
      lastName: 'Apellido del huésped',
      confirmNumber: 'Número de confirmación de reserva/número de PNR',
      ticketNumber: 'Número de billete',
      file: 'Carga de prueba RezSnap™ ',
      arrivalDate: 'Fecha de llegada a la propiedad',
      departureDate: 'Fecha de salida de la propiedad',
      brand: 'Marca reservada',
      lengthOfStay: 'Duración de la estadía',
      cost: 'Costo total de la reserva',
      rooms: 'Número de habitaciones',
      airline: 'Aerolínea/compañía de transporte (código de 2 dígitos)',
      gateway: 'Puerta de origen (código de aeropuerto de 3 letras)',
      destination: 'Destino/isla (código de aeropuerto de 3 letras)',
      disclaimer: '* Campos obligatorios',
      button: 'Enviar tu reserva',
      sub: 'Tu información',
      sub2: 'Información de reserva',
      travelDepartureDate: 'Fecha de salida del viaje',
      travelReturnDate: 'Fecha de regreso del viaje',
      flightNumber: 'Número de vuelo vinculado a EE. UU.',
      numberOfTravelers: 'Número de viajeros',
      edit: 'Editar tu información',
      fileUploaded: 'El archivo se cargó correctamente',
      select: 'Selecciona una de las siguientes opciones',
      drag: 'Arrastre y suelte un archivo aquí, o haga clic para seleccionarlo.',
      fileType: '(Se aceptarán archivos .jpeg, .png y .pdf. El tamaño máximo del archivo es de 100 MB.)',
      maxSize: 'El tamaño máximo del archivo es 100 mb',
    },
    TermsAndConditions: {
      title: 'Términos y condiciones del programa',
      subTitle: 'Recompensas trimestrales especializadas',
      body1:
        'Todas las publicaciones deben ir acompañadas de un documento de prueba de venta con saldo cero que corresponda a cada reserva individual publicada. Los ganadores se seleccionarán en función de la totalidad de documentos de prueba de venta que se verifiquen y correspondan a cada reserva indicada. Las publicaciones deben seguir todas las reglas del Programa de descubrimiento de Estados Unidos para su elegibilidad.',
      body2:
        'Para ser elegible, debes residir en Estados Unidos o Brand USA, y ser mayor de edad en el estado, provincia o territorio de residencia. Los empleados de operadores turísticos NO son elegibles para sorteos y NO se considerarán para premios adicionales. Los residentes de la provincia de Quebec NO son elegibles para sorteos y NO se considerarán para premios adicionales.',
      body3:
        'La emisión de recompensas puede requerir una prueba de acreditación como asesor de viajes en el comercio minorista o a domicilio. Las recompensas disponibles están sujetas a cambios durante el transcurso del programa.',
      body4: 'Privacidad y uso de la información personal',
      body5:
        'Los agentes participantes (i) conceden al ganador el derecho de usar su nombre, ciudad, estado, provincia, código postal, confirmación de mayoría de edad, número de teléfono y dirección de correo electrónico para, entre otros, contactar y anunciar a los ganadores y para la entrega de premios; (ii) conceden al ganador el derecho de utilizar su información personal con fines de publicidad y promoción relacionados con los premios, en todos y cada uno de los medios de comunicación conocidos en la actualidad o que se creen en el futuro, sin compensación adicional, a menos que esté prohibido por la ley; y (iii) reconocen que los ganadores pueden divulgar su información personal a agentes externos y proveedores de servicios en relación con cualquiera de las actividades enumeradas en (i) y (ii) anteriores.',
      button: 'Volver a la página de inicio',
    },
    thankYouPage: {
      thanks: 'Gracias',
      congrats: 'Felicidades, ',
      body: 'recibimos tu reserva y la enviamos al supervisor de campaña para su verificación.',
      link: 'Ten en cuenta que para ganar, debes haber completado los Fundamentos del Programa de descubrimiento de Estados Unidos',
    },
  },
  facts: {
    title: '¿Sabías que?',
  },
  badgeView: {
    other: 'Socios Regionales',
    unlock: 'Comienza a completar ítems de capacitación para recibir insignias',
    title: 'Logros de Capacitación',
    subtitle:
      'Bienvenido a tu panel de Logros, donde puedes ver, seguir y descargar tu diploma e insignias de especialización.',
    viewBadge: 'Ver Estado',
    badgeDisplayTitle: 'ESTADO DE RECOMPENSAS METÁLICAS',
    badgeAchievement:
      '¡Has alcanzado el Estado {rank}! Haz clic en el icono de la derecha para ver y compartir tu estado.',
    badgesCompleteTitle: 'Tus insignias de especialización',
    badgesCompleteSubtitle: 'Haz clic en los iconos para ver, guardar y compartir tus insignias.',
    badgesIncompleteSubtitle: 'Gana más insignias completando estos capítulos.',
    bronze: 'Bronce',
    silver: 'Plata',
    gold: 'Oro',
    platinum: 'Platino',
    diploma: 'Diploma',
    experiencesBadgesSectionTitle: 'Las insignias de Experiencias',
    itinerariesBadgesSectionTitle: 'Insignias de itinerarios',
    partnerSpecializationBadgesSectionTitle: 'Insignias de especialización de socios',
    complete: 'COMPLETO',
  },
  missing: {
    discover: 'Descubrir',
    pacific: 'Pacífico',
    west: 'Oeste',
    southwest: 'Suroeste',
    midwest: 'Medio Oeste',
    south: 'Sur',
    northeast: 'Noreste',
    territories: 'Territorios',
    shoppingAttractions: 'Compras y Atracciones',
    gettingAround: 'Desplazarse',
    regionalPartners: 'Socios Regionales',
    greatOutdoors: 'Gran Naturaleza',
    winterSports: 'Deportes de Invierno',
    coastalEscapes: 'Escapadas Costeras',
    flyDrive: 'Vuelo y Conducción',
    foodDrink: 'Comida y Bebida',
    luxury: 'Lujo',
    musicCultureHeritage: 'Música, Cultura y Patrimonio',
    nationalParks: 'Parques Nacionales',
    regionMap: 'Mapa de la Región',
    videos: 'Videos',
    images: 'Imágenes',
    incentives: 'Incentivo',
    southeast: 'Sureste',
  },
  searchModal: {
    search: 'Buscar',
    subtitle: 'Buscar en todo el contenido',
    pages: 'USA Discovery Program',
    partnerPages: 'Programas de Socios',
    salesCompanion: 'Elementos del Compañero de Ventas',
    exhibitionTiles: 'Escaparates de Socios',
    noResults: 'No se encontraron resultados...',
  },
};
